import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import {
  Grid,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  MenuItem,
  FormGroup,
  Card,
  CardContent,
  FormHelperText,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

import { DeleteOutline, Edit, ViewList } from "@mui/icons-material";
import {
  KeyboardTimePicker,
} from "components/pickers";

//react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import Constants from "../../../services/Constants";
import ProductsLotModal from "../../../services/RepackingLotModal";
// import SourceModal from '../../../services/SourceModal';

import { cellFocusEditor, dateEditor } from "../../../services/Common";

import { fr, enGB } from "date-fns/locale"; // import French and English locale

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";

const DispenserFormData = (props) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "repacking";
  const FacilityId = localStorage.getItem("FacilityId");
  const FacilityName = localStorage.getItem("FacilityName");

  const UsersListByFacility = JSON.parse(
    localStorage.getItem("UsersListByFacility"),
  );

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();
  const ReceiveDetailsRefHolder = useRef({ table: null });
  const ReceiveDetailsRef = ReceiveDetailsRefHolder.current;
  let adjId = null;

  const [hasTimeElapsed, setHasTimeElapsed] = React.useState(false);

  const [open, setOpen] = useState(false);
  const [openLot, setOpenLot] = useState(false);
  const [manyTableData, setManyTableData] = useState([]);
  const [bStockUpdate, setbStockUpdate] = useState(false);
  const [bIsPositive, setbIsPositive] = useState();
  const [IssueToFacility, setIssueToFacility] = useState([]);
  const [swipeIssueToFacility, setswipeIssueToFacility] = useState([]);
  const [IssueToFacilityVal, setIssueToFacilityVal] = useState(false);
  const [firstIssueToFacility, setfirstIssueToFacility] = useState("");
  const [currentAdjType, setcurrentAdjType] = useState("");

  const [bDisableAddProduct, setDisableAddProduct] = useState(
    props.DisableAddBtn,
  );
  const AdjType = JSON.parse(localStorage.getItem("AdjType"));

  const [SoureOpen, setSoureOpen] = useState(false);
  const [currRowId, setCurrRowId] = useState(0);

  const ItemlistAllGroup = JSON.parse(localStorage.getItem("Itemlist"));

  const Itemlist = ItemlistAllGroup.filter(
    (item) => item.ItemGroupId === parseInt(props.formData.ItemGroupId, 10),
  );
  console.log("ItemGroupId === form ID", props.formData.ItemGroupId);
  console.log("ItemGroupId === form ", Itemlist);

  //const Itemlist = ItemlistAllGroup.hasOwnProperty(props.formData.ItemGroupId)?ItemlistAllGroup[props.formData.ItemGroupId]:[];

  const [currProductRepackingTo, setcurrProductRepackingTo] = useState("");

  const [FromProductQty, setFromProductQty] = useState(0);
  const [ToProductQty, setToProductQty] = useState(0);

  //====== Start Choosen Dropdown===========
  const [chosenValues, setChosenValues] = useState({
    ProductRepackingTo: { id: "", name: "" },
    ProductRepackingFrom: { id: "", name: "" },
  });

  useEffect(() => {
    let chosenValuesData = { ...chosenValues };
    chosenValuesData["ProductRepackingTo"] =
      Itemlist.find(
        (Itemlist_List) =>
          Itemlist_List.id == props.formData.ProductRepackingTo,
      ) ?? null;
    chosenValuesData["ProductRepackingFrom"] =
      Itemlist.find(
        (Itemlist_List) =>
          Itemlist_List.id == props.formData.ProductRepackingFrom,
      ) ?? null;
    setChosenValues(chosenValuesData);
  }, [props.formData.ProductRepackingTo, props.formData.ProductRepackingFrom]);

  const handleChangeChoosen = (name, valueobj, value) => {
    let chosenValuesData = { ...chosenValues };
    chosenValuesData[name] = valueobj;
    setChosenValues(chosenValuesData);
    setcurrProductRepackingTo(value);
    props.handleChangeChoosenProps(name, value);
  };

  //====== End Choosen Dropdown===========

  /* =====Start of Print Excel Many Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintMany = () => {
    let finalUrl = EXCEL_EXPORT_URL + "report/repacking_invoice_list_print.php";

    window.open(
      finalUrl +
        "?menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TransactionId=" +
        props.formData.TransactionId +
        "&FacilityId=" +
        FacilityId +
        "&FacilityName=" +
        FacilityName +
        "&TimeStamp=" +
        Date.now() +
        "&isPositive=" +
        props.isPositive,
    );
  };

  const ExcelMany = () => {
    let finalUrl = EXCEL_EXPORT_URL + "report/repacking_invoice_list_excel.php";

    window.open(
      finalUrl +
        "?menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TransactionId=" +
        props.formData.TransactionId +
        "&FacilityId=" +
        FacilityId +
        "&FacilityName=" +
        FacilityName +
        "&TimeStamp=" +
        Date.now() +
        "&isPositive=" +
        props.isPositive,
    );
  };

  /* =====End of Excel Export Code==== */

  const handleClose = (modalname) => {
    switch (modalname) {
      case "Products":
        setOpen(false);
        setOpenLot(false);
        break;
      case "ProductsOpen":
        setOpen(true);
        break;

      case "LotOpen":
        setOpenLot(true);
        break;

      case "SourceOpen":
        setSoureOpen(true);
        break;

      case "SourceClose":
        setSoureOpen(false);
        break;

      default:
        break;
    }
  };
  /*
  const addProduct = (NonOrderProductData) => {

    // let countrs=ReceiveDetailsRef.table.rowManager.displayRowsCount;//ReceiveDetailsRef.table.rowCount(); 

  //   if( bIsPositive){ 
      
  //     let rowsNotInGrid = [];
      
  //     NonOrderProductData.map((row, i) => {
  //       row.TransactionItemId = null; 
  //       row.Remarks = null; 
  //       row.Quantity = 0; 
  //       row.IsPositive = -1; 
  //       row.SKU = i + manyTableData.length+1+props.deleteRepackingInv.length;
  //     });


  //     if (props.ManyTableData.length > 0) {
  //       rowsNotInGrid = NonOrderProductData.filter((obj1) => {
        
  //           return !props.ManyTableData.some((obj2) => (obj1.BatchNo === obj2.BatchNo && obj1.ExpiryDate === obj2.ExpiryDate && obj1.ItemCode === obj2.ItemCode ));
          
  //       });
  //     } else {
  //       rowsNotInGrid = NonOrderProductData;
  //     }

  //     let arrObjOne=rowsNotInGrid.concat(props.ManyTableData)  ; 
  //     //const arrObjOne = [...new Map(person.map(item => [JSON.stringify(item), item])).values()];
         
  //       setManyTableData(arrObjOne);
  //       props.handleAdd(arrObjOne);
        
  //       handleClose("Products");
    
  // }else{

      let rows = [];
      let autoId=0;
      manyTableData.forEach((row,i) => {
        autoId++;
        let newRow={} ; 
        newRow.ItemNo =row.ItemNo;
        newRow.ItemCode =row.ItemCode;
        
        newRow.ItemName =row.ItemName;
        newRow.UnitPrice =row.UnitPrice; 
        newRow.TransactionItemId = row.TransactionItemId; 
        newRow.CurrentStockQty = row.CurrentStockQty;
        newRow.Quantity =row.Quantity;
        newRow.BatchNo = row.BatchNo;
        newRow.ExpiryDate =row.ExpiryDate;
        newRow.Remarks =row.Remarks;

        newRow.SourceId = row.SourceId;
        newRow.SourceName = row.SourceName;

        newRow.SKU=autoId;
        newRow.id=autoId; 
        newRow.LineTotal=row.Quantity*row.UnitPrice; 
        rows.push(newRow);
        
      });

      NonOrderProductData.forEach((row,i) => {
          autoId++;
          let newRow={} ;
          newRow.ItemNo =row.ItemNo;
          
          newRow.ItemCode =row.ItemCode;
        
          newRow.ItemName =row.ItemName;
          newRow.UnitPrice =row.UnitPrice;

          newRow.TransactionItemId = null; 
          newRow.CurrentStockQty = row.CurrentStockQty;
          newRow.Quantity = row.RepackingQty;
          newRow.BatchNo = row.BatchNo;
          newRow.ExpiryDate = row.ExpiryDate;
          newRow.Remarks =null;

          newRow.SourceId = row.SourceId;
          newRow.SourceName = row.SourceName;

          newRow.SKU=autoId; 
          newRow.id=autoId;  
          newRow.LineTotal=0; 
          rows.push(newRow);
        
      });

      setManyTableData(rows);
      props.handleAdd(rows); 
      handleClose("Products");

  // }
};
*/
  // const addSource = (productSourceData) => {
  //   if (!productSourceData) {
  //     return;
  //   }

  //   let tempProductSourceData = productSourceData[0];
  //   let rows = [];

  //   let autoId = Date.now(); // 0;

  //   manyTableData.forEach((row, i) => {
  //     autoId++;
  //     let newRow = {};

  //     if (row.SKU === currRowId) {
  //       newRow.SourceId = tempProductSourceData.SourceId;
  //       newRow.SourceName = tempProductSourceData.SourceName;

  //     } else {
  //       newRow.SourceId = row.SourceId;
  //       newRow.SourceName = row.SourceName;
  //     }

  //     newRow.ItemNo =row.ItemNo;
  //     newRow.ItemCode =row.ItemCode;

  //     newRow.ItemName =row.ItemName;
  //     newRow.UnitPrice =row.UnitPrice;
  //     newRow.TransactionItemId = row.TransactionItemId;
  //     newRow.CurrentStockQty = row.CurrentStockQty;
  //     newRow.Quantity =row.Quantity;
  //     newRow.BatchNo = row.BatchNo;
  //     newRow.ExpiryDate =row.ExpiryDate;
  //     newRow.SKU=row.SKU;
  //     newRow.id=row.id;
  //     newRow.LineTotal=row.Quantity*row.UnitPrice;
  //     rows.push(newRow);

  //   });

  //   setManyTableData(rows);
  //   props.handleAdd(rows);
  //   handleClose("SourceClose");

  // };
  /*
  function ShowSourcePopup(propss: any) {

    const rowData = propss.cell._cell.row.data;
    
    if ((props.bStockUpdate) || (props.isPositive)) {
      return <></>;
    } else {
        return (
          <>
            <ViewList 
              onClick={() => {
                setCurrRowId(rowData.SKU);
                handleClose("SourceOpen");
              }}
            />
          </>
        );
    }
  }
*/
  const ReceiveDetailsColumns = [
    { title: "id", field: "SKU", visible: false },
    { title: "id", field: "TransactionItemId", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      width: 70,
      formatter: "rownum",
      hozAlign: "center",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Code"]),
      field: "ItemCode",
      width: 130,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Name"]),
      field: "ItemName",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Current Stock"]),
      field: "CurrentStockQty",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
      visible: bIsPositive,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Quantity"]),
      field: "Quantity",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
      validator: [
        "integer",
        "min:0",
        function (cell, value, parameters) {
          if (value == "") return true;
          if (!props.isPositive) return true;
          const balance = cell.getRow().getCell("CurrentStockQty").getValue();
          const validstatus = parseInt(value) <= parseInt(balance);
          return validstatus;
        },
      ],
      cssClass: "tabluator-column-editable",
      editor: props.bStockUpdate == 0 ? cellFocusEditor : "",
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
        const pricecell = currow.getCell("LineTotal");
        const totprice = rowdata.UnitPrice * curcellval;
        pricecell.setValue(totprice);
        calculateFromAndToTotalQty();

        // props.setUpdatedDetailsGridDataHandler(currow._row.data);
      },
    }, //
    {
      title: t(DispensingLanguage[lan][menukey]["Lot No"]),
      field: "BatchNo",
      width: 100,
      //cssClass: "tabluator-column-editable text-field-editable",
      //editor: props.bStockUpdate == 0 ? (props.isPositive?false: cellFocusEditor)   : "",
      /* cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
       // props.setUpdatedDetailsGridDataHandler(rowdata);
      }, */
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Expiry Date"]),
      field: "ExpiryDate",
      width: 100,
      /*  cssClass: "tabluator-column-editable",
      editor: props.bStockUpdate == 0 ? (props.isPositive?false: dateEditor)  : "",
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
       // props.setUpdatedDetailsGridDataHandler(rowdata);
      }, */
    },
    {
      title: "SourceId",
      field: "SourceId",
      visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Source"]),
      field: "SourceName",
      width: 120,
    },
    // {
    //   title: "",
    //   headerSort: false,
    //   field: "custom",
    //   hozAlign: "center",
    //   width: 8,
    //   visible: false,
    //   formatter: reactFormatter(<ShowSourcePopup />),
    // },
    {
      title: t(DispensingLanguage[lan][menukey]["Unit Price (CFA)"]),
      field: "UnitPrice",
      width: 100,
      visible: false,
      hozAlign: "right",
      headerHozAlign: "right",
      validator: ["float", "min:0"],
      //cssClass: "tabluator-column-editable",
      // editor: bStockUpdate == 0 ?  (props.isPositive?false: cellFocusEditor)  : "",
      editor: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Line Total (CFA)"]),
      field: "LineTotal",
      width: 110,
      formatter: "money",
      visible: false,
      hozAlign: "right",
      headerHozAlign: "right",
      bottomCalc: "sum",
      bottomCalcFormatter: "money",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Comment"]),
      field: "Remarks",
      width: 110,
      hozAlign: "left",
      visible: false,
      headerHozAlign: "left",
      cssClass: "tabluator-column-editable text-field-editable",
      editor: props.bStockUpdate == 0 ? cellFocusEditor : "",

      formatter: function (cell, formatterParams) {
        const cellValue = cell.getValue();
        const rowData = cell.getRow().getData();

        if (cellValue == null || cellValue == "") {
          // cell.getRow().getElement().style.backgroundColor = "#ec7063";
        } else {
          // cell.getRow().getElement().style.backgroundColor = "transparent";
        }

        return cellValue;
      },
    },
    {
      //visible: bStockUpdate == 0 ?true:false,
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      headerSort: false,
      visible: false,
      headerHozAlign: "center",
      hozAlign: "center",
      width: 100,
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  const calculateFromAndToTotalQty = () => {
    let fromQty = 0;
    let toQty = 0;

    let fromPacksize = 1;
    let toPacksize = 1;
    console.log("manyTableData:", manyTableData);

    manyTableData.forEach((row, i) => {
      if (row.Quantity != "" && row.Quantity != null && row.IsPositive == -1) {
        fromQty += parseInt(row.Quantity);
      }

      if (
        row.PacksizeName != "" &&
        row.PacksizeName != null &&
        row.IsPositive == -1
      ) {
        fromPacksize = parseInt(row.PacksizeName);
      }

      if (row.PacksizeNameTo != "" && row.PacksizeNameTo != null) {
        toPacksize = parseInt(row.PacksizeNameTo);
      }
    });
    console.log("fromPacksize: ", fromPacksize);
    console.log("fromQty: ", fromQty);

    console.log("toPacksize: ", toPacksize);
    toQty = parseInt((fromQty * fromPacksize) / toPacksize);
    console.log("toQty: ", toQty);

    setFromProductQty(fromQty);
    setToProductQty(toQty);
  };
  // const ReceiveDetailsDataItems = props.ManyTableData?.map((item, index) => {
  //    item["sl"] = index + 1;

  //   item["LineTotal"] = item.Quantity * item.UnitPrice;
  //   return item;
  // });

  const onPostBtnClick = () => {
    setbStockUpdate(true);
    props.handlePost();
  };

  const onSaveUpdateBtnClick = () => {
    if (props.isSubmitting) return;
    props.setUpdatedDetailsGridDataHandler({
      datatype: "TableData",
      data: ReceiveDetailsRef.table.getData(),
    });
    //  props.handleUpdate();
  };

  const deleteRepackingInv = (data) => {
    let newarray = manyTableData.filter((element) => element !== data);
    setManyTableData(newarray);
    props.deleteRepackingInv(data);
  };

  // const [pickListMethod, setPickListMethod] = useState();

  const { mutate } = useMutation(api.getWarehouseList, {
    onSuccess: (data) => {
      if (data.status == 200) {
        let firstIssueToFacility =
          data.data.datalist.length == 1 ? data.data.datalist[0].id : "";
        setfirstIssueToFacility(firstIssueToFacility);
        props.formData.IssueToFacility = firstIssueToFacility;

        props.setUpdatedDetailsGridDataHandler({
          datatype: "FormData",
          IssueToFacility: props.formData,
        });

        setIssueToFacility(data.data.datalist);
      }
    },
  });

  function ActionButton(props) {
    const rowData = props.cell._cell.row.data;

    const cellValue = props.cell._cell.value || "Edit | Show";
    if (bStockUpdate == 0)
      return (
        <>
          <DeleteOutline
            onClick={() => {
              if (!bStockUpdate) deleteRepackingInv(rowData);
            }}
          />
        </>
      );
    else return <></>;
  }
  let bfalse = true;
  useEffect(() => {
    if (props.bFirst) {
      setManyTableData(props.ManyTableData);
      calculateFromAndToTotalQty();
    }

    setbStockUpdate(props.bStockUpdate === 1 ? true : false);

    setbIsPositive(props.isPositive);
    if (!props.addProductForm)
      if (props.pickListMethod != undefined) {
        //setswipeIssueToFacility
        bfalse = false;
        setIssueToFacilityVal(props.formData.IssueToFacility);
        let params = {
          action: "getWarehouseFacility",
          menukey: menukey,
          FacilityId: FacilityId,
          PickListMethod: props.pickListMethod,
        };
        mutate(params);
      }
  }, [
    props.ManyTableData,
    props.bStockUpdate,
    props.isPositive,
    props.pickListMethod,
  ]); //

  useEffect(() => {
    //  setIssueToFacilityVal(true);
    console.log(IssueToFacility);
    //  console.log("gjsdfhhfksdfhdgfhfdsfshjdf==="+props.formData.IssueToFacility+'lkp'+IssueToFacilityVal);
    props.formData.IssueToFacility = IssueToFacilityVal;
    bfalse = true;
  }, [IssueToFacility]); //

  const handleATCChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    props.formData.IssueToFacility = rowId;
    setIssueToFacilityVal(rowId);
    if (rowId != "") props.handleChange("IssuedToFacility");
    // let data = { ...formData };
    // data['atc'] = rowId;
    // setFormData(data);
  };

  const handleReset = () => {
    setManyTableData([]);
    props.handleReset();
  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid container>
            <Grid item xs={12} sm={12}>
              <div className="sw_page_heading">
                <div className="sw_heading_title">
                  {DispensingLanguage[lan][menukey]["Repacking - Add/Edit"]}
                </div>

                <div className="float-end sw_btn_control">
                  {props.addProductForm ? (
                    <Grid item xs={12} className="mt-4 text-center">
                      <div className="float-end sw_btn_control">
                        <Button
                          className="me-2"
                          variant="contained"
                          color="gray"
                          type="reset"
                          onClick={() => handleReset()}
                          // onClick={() => props.handleReset()}
                        >
                          {DispensingLanguage[lan][menukey]["Reset"]}
                        </Button>
                        <Button
                          className="me-2"
                          variant="contained"
                          color="primary"
                          disabled={!!props.isSubmitting}
                          onClick={onSaveUpdateBtnClick} //() => props.handleSubmit()
                        >
                          {DispensingLanguage[lan][menukey]["Save"]}
                        </Button>
                        <Button
                          className="me-2"
                          variant="contained"
                          color="gray"
                          type="reset"
                          onClick={() => props.history.push("/repacking")}
                        >
                          {DispensingLanguage[lan][menukey]["Back to List"]}
                        </Button>
                      </div>
                    </Grid>
                  ) : (
                    <Grid item xs={12} className="mt-2 text-center">
                      <Button
                        disabled={
                          !!props.bStockUpdate || !!props.isSubmitting
                        }
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={onSaveUpdateBtnClick} //() => props.handleUpdate()
                      >
                        {DispensingLanguage[lan][menukey]["update"]}
                      </Button>
                      <Button
                        disabled={
                          !!props.bStockUpdate || !!props.isSubmitting
                        }
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={onPostBtnClick}
                      >
                        {DispensingLanguage[lan][menukey]["post"]}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/repacking")}
                      >
                        {DispensingLanguage[lan][menukey]["Back to List"]}
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        className="me-2 sw_icons"
                        onClick={() => PrintMany()}
                      >
                        <i className="fas fa-print"></i>
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        className="me-2 sw_icons"
                        onClick={() => ExcelMany()}
                      >
                        <i className="far fa-file-excel"></i>
                      </Button>
                    </Grid>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <Grid container spacing={3}>
          <Grid item xs={3} sm={3}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
              <DatePicker
                disabled={!!props.bStockUpdate}
                // disableToolbar
                label={DispensingLanguage[lan][menukey]["Adj. Date"]}
                //
                value={props.formData.TransactionDate || props.selectedDate}
                inputFormat="dd/MM/yyyy"
                onChange={(e) => props.handleRDateChange(e, "TransactionDate")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    required
                    error={!!props.errorObject.TransactionDate}
                    helperText={props.errorObject.TransactionDate}
                    className={classes.fullWidth}
                    id="TransactionDate"
                    name="TransactionDate"
                    fullWidth
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={3} sm={3}>
            <TextField
              variant="standard"
              disabled={true /*bStockUpdate*/}
              error={!!props.errorObject.TransactionNo}
              helperText={props.errorObject.TransactionNo}
              required
              id="TransactionNo"
              name="TransactionNo"
              label={DispensingLanguage[lan][menukey]["Adj. Invoice No"]}
              value={props.formData.TransactionNo || props.generatedInvoiceNo}
              fullWidth
              autoComplete="family-name"
              onChange={(e) => props.handleChange(e)}
            />
          </Grid>

          <Grid item xs={3} sm={3}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["Prepared By"]} *
              </InputLabel>
              <Select
                error={!!props.errorObject.PreparedBy}
                // helperText={props.errorObject.OrderBy}
                required
                labelId="demo-simple-select-helper-label"
                id="PreparedBy"
                name="PreparedBy"
                value={props.formData.PreparedBy}
                fullWidth
                onChange={(e) => props.handleChange(e)}
                disabled={!!props.bStockUpdate}
                //disabled={bCompleted===1}
                label={`${DispensingLanguage[lan][menukey]["Prepared By"]} *`}
              >
                {UsersListByFacility.map((item, index) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>

              <FormHelperText error={!!props.errorObject.PreparedBy}>
                {props.errorObject.PreparedBy}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={3}>
            <FormControl variant="standard" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-helper-label">
                {DispensingLanguage[lan][menukey]["Approved By"]} *
              </InputLabel>
              <Select
                error={!!props.errorObject.ApprovedBy}
                // helperText={props.errorObject.ApprovedBy}
                required
                labelId="demo-simple-select-helper-label"
                id="ApprovedBy"
                name="ApprovedBy"
                value={props.formData.ApprovedBy}
                fullWidth
                onChange={(e) => props.handleChange(e)}
                disabled={!!props.bStockUpdate}
                //disabled={bCompleted===1}
                label={`${DispensingLanguage[lan][menukey]["Approved By"]} *`}
              >
                {UsersListByFacility.map((item, index) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>

              <FormHelperText error={!!props.errorObject.ApprovedBy}>
                {props.errorObject.ApprovedBy}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={5} sm={5}>
            <FormControl className={classes.fullWidth}>
              <Autocomplete
                autoHighlight
                //disableClearable
                disabled={Boolean(
                  manyTableData.length > 0 ? true : props.bStockUpdate,
                )}
                id="ProductRepackingFrom"
                options={Itemlist}
                onChange={(event, valueobj) =>
                  handleChangeChoosen(
                    "ProductRepackingFrom",
                    valueobj,
                    valueobj ? valueobj.id : "",
                  )
                }
                getOptionLabel={(option) => option?.name ?? ""}
                isOptionEqualToValue={(option, value) =>
                  value?.id == null || option?.id === value?.id
                }
                value={chosenValues["ProductRepackingFrom"] || null}
                renderOption={(props, option) => (
                  <li {...props} key={option.id ?? option.name}>
                    <Typography className="sw_fontSize">
                      {option.name}
                    </Typography>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={props.formData.ProductRepackingFrom}
                    label={
                      DispensingLanguage[lan][menukey][
                        "Product Repacking From"
                      ] + " *"
                    }
                    variant="standard"
                    error={!!props.errorObject.ProductRepackingFrom}
                    helperText={props.errorObject.ProductRepackingFrom}
                    id="ProductRepackingFrom"
                    name="ProductRepackingFrom"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={5} sm={5}>
            <FormControl className={classes.fullWidth}>
              <Autocomplete
                autoHighlight
                //disableClearable
                disabled={Boolean(
                  manyTableData.length > 0 ? true : props.bStockUpdate,
                )}
                id="ProductRepackingTo"
                options={Itemlist}
                onChange={(event, valueobj) =>
                  handleChangeChoosen(
                    "ProductRepackingTo",
                    valueobj,
                    valueobj ? valueobj.id : "",
                  )
                }
                getOptionLabel={(option) => option?.name ?? ""}
                isOptionEqualToValue={(option, value) =>
                  value?.id == null || option?.id === value?.id
                }
                value={chosenValues["ProductRepackingTo"] || null}
                renderOption={(props, option) => (
                  <li {...props} key={option.id ?? option.name}>
                    <Typography className="sw_fontSize">
                      {option.name}
                    </Typography>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={props.formData.ProductRepackingTo}
                    label={
                      DispensingLanguage[lan][menukey]["Product Repacking To"] +
                      " *"
                    }
                    variant="standard"
                    error={!!props.errorObject.ProductRepackingTo}
                    helperText={props.errorObject.ProductRepackingTo}
                    id="ProductRepackingTo"
                    name="ProductRepackingTo"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={3}>
            <TextField
              variant="standard"
              id="FacilityId"
              name="FacilityId"
              label="FacilityId"
              value={props.formData.FacilityId}
              fullWidth
              hidden
              autoComplete="family-name"
            />
            <TextField
              variant="standard"
              id="TransactionId"
              name="TransactionId"
              label="TransactionId"
              value={props.formData.TransactionId || ""}
              fullWidth
              hidden
              autoComplete="family-name"
            />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardContent>
                <Grid item xs={12} sm={12}>
                  <Grid container className="mb-2">
                    <Grid item xs={4} sm={4}>
                      {" "}
                    </Grid>

                    <Grid item xs={3} sm={3}>
                      <div>
                        <span>
                          {"From product quantity"}
                          {": "}
                          <b>{FromProductQty}</b>
                        </span>
                        {/*  <span>{"From product quantity"}{": "}<b>{FromProductQty}</b></span> &nbsp;&nbsp; <span>{"To product quantity"}{": "}<b>{ToProductQty}</b></span> */}
                      </div>
                    </Grid>

                    <Grid item xs={3} sm={3}>
                      <span>
                        {"To product quantity"}
                        {": "}
                        <b>{ToProductQty}</b>
                      </span>
                    </Grid>

                    <Grid item xs={3} sm={3}></Grid>
                  </Grid>
                </Grid>
                <ReactTabulator
                  onRef={(r) => {
                    ReceiveDetailsRef.table = r.current;
                  }}
                  columns={ReceiveDetailsColumns}
                  data={manyTableData}
                  height="350px"
                  layout={"fitColumns"}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default DispenserFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
